import { Container, Stack, ThemeProvider } from "@mui/material";
import OnboardingTheme from "../OnboardingTheme";
import { Outlet } from "react-router-dom";

const OnboardingLayout = () => {
    return (
        <ThemeProvider theme={OnboardingTheme}>
            <Stack height="100%">
                <Stack
                    flex={1}
                    sx={{
                        background: ({ palette }) => `linear-gradient(180deg, ${palette.primary.dark} 0%,  ${palette.primary.main} 100%)`,
                    }}
                >
                    <Stack flex={1} padding={2} alignItems="center" justifyContent="center">
                        <Container maxWidth="md">
                            <Outlet/>
                        </Container>
                    </Stack>
                </Stack>
            </Stack>
        </ThemeProvider>
    )
}

export default OnboardingLayout;
